$(document).ready(function(){
    // Sticky header
    var $header = $("#header");
    var $topbar = $(".header-topbar");
    var $navbar = $("#navbar");
    
    // toggle scroll class on page scroll
    if($header.length && $topbar.length) {
        var observer = new IntersectionObserver( function(e){
                if(e.length){
                    $header.toggleClass("sticky", e[0].intersectionRatio < 1);
                }
            },
            { threshold: [1] }
        );
        observer.observe($topbar[0]);
    }
    else if($header.length) {
        $header.addClass("sticky");
    }
    
    // Toggle scroll class on mobile menu open and close
    $navbar.on('show.bs.collapse', function () {
        $('body').addClass('navbar-show');
    });
    $navbar.on('hide.bs.collapse', function () {
        $('body').removeClass('navbar-show');
    });
    
});